import { Dispatch, SetStateAction } from 'react';
import { DropResult } from 'react-beautiful-dnd';
import { Item } from './DraggableListItem';

export const reorder = <T>(list: T[], startIndex: number, endIndex: number): T[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const onDragEndWithTwoParts = (
  { destination, source }: DropResult,
  items: Item[],
  itemsRight: Item[],
  setItems: Dispatch<SetStateAction<Item[]>>,
  setItemsRight: Dispatch<SetStateAction<Item[]>>,
) => {
  // dropped outside the list
  if (!destination) return;

  if (source.droppableId === 'droppable-list' && destination.droppableId === 'droppable-list') {
    const result = Array.from(items);
    const [removed] = result.splice(source.index, 1);
    result.splice(destination.index, 0, removed);
    setItems(result);
    return;
  } else if (source.droppableId === 'droppable-list-2' && destination.droppableId === 'droppable-list-2') {
    const result = Array.from(itemsRight);
    const [removed] = result.splice(source.index, 1);
    result.splice(destination.index, 0, removed);
    setItemsRight(result);
    return;
  }

  const sourceItems = source.droppableId === 'droppable-list' ? Array.from(items) : Array.from(itemsRight);
  const destinationItems = destination.droppableId === 'droppable-list' ? Array.from(items) : Array.from(itemsRight);
  const [removed] = sourceItems.splice(source.index, 1);

  destinationItems.splice(destination.index, 0, removed);

  if (source.droppableId === 'droppable-list') {
    setItems(sourceItems);
  } else {
    setItemsRight(sourceItems);
  }

  if (destination.droppableId === 'droppable-list') {
    setItems(destinationItems);
  } else {
    setItemsRight(destinationItems);
  }
};
